import posthog, { PostHog } from 'posthog-js'

function initPosthog(apiKey: string, config: object): void | PostHog {
  return posthog.init(apiKey, config)
}

export default initPosthog
export { initPosthog }
